module.exports = __webpack_public_path__ + "img/prepare-food.f769bdc2.svg";